import React, { Component } from "react";
import {getFavoriteTopics,addFavoriteTopics,removeFavoriteTopics,sectionlist,sectionlist_all} from '../config/Variables';
import {baseurl} from '../config/Settings';
import FetchOwnSectionsPopup from '../components/FetchOwnSectionsPopup';
import FetchSectionspopup from '../components/FetchSectionspopup';


export default class FetchOwnSections extends Component {

  constructor() {
   super();
    this.state = {
      hobbies: [],
      sectionslist: [],
      tid: '',
      runscr:'initial',
      messagelog: '',
      isLoading: true,
      loading: true,
      users: [],
      numberstid: [],
      error: null
    }
    this.Removetid = this.Removetid.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
   
  }
  handleChecknow = (evnt) => {

    this.state.runscr="refresh";
    this.getFetchUsersdrupal(evnt);
 
   }

  async Removetid(event) {

    const target = event.target;
      var value = target.value;
      var index=target.key;
  
      if (event.target.checked) {
       // this.state.hobbies.push(value);
        if (localStorage.getItem('user-info')) {
          const tid = value
  
          let item = { tid };
          let user = JSON.parse(localStorage.getItem('user-info'))
          let result =  await fetch(addFavoriteTopics, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": 'application/json',
              "Authorization": "Bearer " + user.token.access_token,
            },
            body: JSON.stringify(item)
          });
          result = await result.json();
    
          if (result.message.code == '200') {
            //localStorage.setItem("user-info", JSON.stringify(result));
            //history('/add');
            this.getFetchSections();
  
          }
        }
       // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
      } else {
   // const index = (this.state.hobbies).indexOf(parseInt(value, 2));
   
  
   
        if (localStorage.getItem('user-info')) {
          const tid = value
          const box = target.id;
          event.target.checked=true;
  
          let item = { tid };
          let user = JSON.parse(localStorage.getItem('user-info'))
          let result =  await fetch(removeFavoriteTopics, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": 'application/json',
              "Authorization": "Bearer " + user.token.access_token,
            },
            body: JSON.stringify(item)
          });
          result = await result.json();
    
          if (result.message.code == '200') {
            
            this.state.users= this.state.users.filter(user => {
                  return user.tid !== value ;
                });
            
             //this.props.fetchpopupcallback(tid);
             if(this.state.users.length==0)
              document.getElementById('tag-'+tid).style.display = "none";
            this.props.fetchpopupcallback(tid);

             this.props.fetchownsectioncallback(this.state.users.length);
            }
        }
       // this.state.hobbies.splice(value, 1);
      }
    }

  handleInputChange(event) {
    const target = event.target;
    var value = target.value;
    if (target.checked) {
      this.state.hobbies.push(value);
     // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {
      
    // this.state.hobbies= this.state.hobbies.filter(a => a !== value);

      const index = this.state.hobbies.indexOf(value);
      
      if (index > -1) {
        this.state.hobbies.splice(index, 1);
        this.state.hobbies.splice(index, 1)
        const x = this.state.hobbies.indexOf(value);
        if (this.state.hobbies.indexOf(value) > -1) {
          this.state.hobbies.splice(index, 1);
         } // 2nd parameter means remove one item only
      }



     // this.state.hobbies.splice(value, 1);
    }
  }
  
  getFetchUsers() {
    var ss=this.state.sectionslist.join('+');
    this.setState({
      loading: true
    }, () => {
      fetch(sectionlist_all).then(res => res.json()).then(result => this.setState({
        loading: false,
        users: result
      })).catch(console.log);
    });
  }

  getFetchSections() {

var sectionstring='';
    let user = JSON.parse(localStorage.getItem('user-info'))
         let datt = fetch(getFavoriteTopics, {
           method: 'POST',
           headers: {
             "Content-Type": "application/json",
             "Accept": 'application/json',
             "Authorization": "Bearer " + user.token.access_token,
           },
           body: JSON.stringify(this.state)
         }).then(response => response.json())
           .then(data => {
             data.data.map(({ tid }, index2) => {
              sectionstring =tid + '+' + sectionstring ;
              // this.state.numberstid.push(tid);
               //this.setState({ numberstid: [this.state.numberstid, tid] })
             //  this.setState({ numberstid: this.state.numberstid })
               this.state.sectionslist.push(tid);
             });
             var ss=this.state.sectionslist.join('+');
             this.getFetchSectionsdrupal(this.state.sectionslist);
         

              fetch(sectionlist+ss+"?"+ Math.floor(Math.random() * 90000)).then(res => res.json()).then(result => this.setState({
                loading: false,
                users: result
              })).catch(console.log);
           
          
           });
           
           //var ss=this.state.sectionslist.join('+');
           
         

   }

   getFetchSectionsdrupal(parametersvalue){
    var ss = parametersvalue.join('+');
    if(ss ===""){
      ss="none";
    }
    fetch(sectionlist+ss+"?"+ Math.floor(Math.random() * 90000)).then(res => res.json()).then(result => this.setState({
      loading: false,
      users: result
    })).catch(console.log);
   }


  componentDidMount() {
    this.getFetchSections();
    //this.getFetchUsers();

 
  }

  render() {
    const {
      users,
      error,
      loading
    } = this.state;

  

    if(loading){

      return (
<div className="loading-mypage" >  {loading ?<img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?ss" />: ""}</div>
      );

    }else{
    return (
      <>
      <div className="my-tags list-scroll">
      <div className="tags-list">
        <div className="add-more button round show-for-large modal-toggle" data-id="modal-tags">
          <i className="icomoon-icon icon-plus-green"></i> <span>أضف موضوعاتك المفضلة</span>
        </div>
        <React.Fragment>
        {
            users.map(({ name, tid }, index) => {
              if(index <11 ){
                return (
                <div className="tag-option" id={`tag-${tid}`} key={index}>
                    <label for={`custom-ownsection-checkbox-${index}`} className="multi-check">
                        <input type="checkbox" id={`custom-ownsection-checkbox-${index}`} name="hobbiessection"   defaultChecked={true}  defaultValue={`${tid}`} onTouchEnd={this.Removetid} onClick={this.Removetid}  className="form-check"  />
                        <div className="tag">{name}</div>
                    </label>
                </div>
                );
              }

            
            })
        }
        </React.Fragment>
        <div className=" show-for-large modal-toggle see-more-link primary" data-id="modal-tags-checked">
          {users.length > 10 ? `اعرض الكل(${users.length})` : ""}
        </div>
          
</div>
</div>
 <div className="add-more hide-for-large modal-toggle" data-id="modal-tags">
 <i className="icomoon-icon icon-plus-green"></i>  <span className="hide-for-large">تابع المزيد من المواضيع</span>
</div>
  {users.length > 10 ? <FetchOwnSectionsPopup userslist={users} /> : "" }
  <FetchSectionspopup  userslist={users} />
</>
    );
      }
}
}
